import { connect } from 'react-redux'
import * as action from '../../state/file-upload/action'
import * as customerAction from '../../state/detail/action'
import * as selector from '../../state/file-upload/selector'
import CustomerFileUpload from './CustomerFileUpload'
import { FILE_TYPE_TREATMENT_PLAN } from '../../state/const'
import { TREATMENT_PLAN_FILE_UPLOAD_WIDGET } from '../../../process/ui-definition/process-ui'


const mapStateToProps = (state, props) => {
    return {
        ...selector.selectOwnState(state),
        fetching: selector.selectIsFetching(state, FILE_TYPE_TREATMENT_PLAN),
        fileType: FILE_TYPE_TREATMENT_PLAN,
        visualizationRequested: selector.selectVisualizationRequested(state),
        widgetId: TREATMENT_PLAN_FILE_UPLOAD_WIDGET,
        taskName: props.taskName,
    }
}

const mapDispatchToProps = {
    uploadCustomerFile: action.uploadCustomerFile,
    setDeleteFlag: action.setDeleteFlag,
    onUploadSuccess: customerAction.addCustomerFile,
    onFileDeleteFlagSuccess: customerAction.onFileDeleteFlagSuccess,
    triggerVisualization: action.triggerVisualization,
}


export default connect(mapStateToProps, mapDispatchToProps)(CustomerFileUpload)



// WEBPACK FOOTER //
// ./src/modules/customer/component/scan-file-upload/TreatmentPlanFileUploadContainer.js